export default __webpack_public_path__ + "static/media/fea3.208a0c63.jpg";